import { WhiteBlock } from '../../../../components/Basic/Blocks';
import WarehouseHistoryBlock from './Content';
import styles from './styles.module.scss';

const WarehouseProductHistory = ({ history = [], save = (_) => _ }) => {
  return (
    <WhiteBlock title="История изменения" className={styles.market_block} minimize={true}>
      {history.map((item) => (
        <WarehouseHistoryBlock part={item} key={item['_id']} />
      ))}
    </WhiteBlock>
  );
};

export default WarehouseProductHistory;
